import React from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import './Header.css';

const Header = () => {
    return (
        <div>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar className="app-bar" position="static">
                    <Toolbar>
                        <Typography style={{fontFamily: 'Fasthand' , fontSize:40}} variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            Codemate
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
        </div>
    )
}

export default Header;